import { apiUrl } from "../../utils/url";
import { FILE_TRANSFER_TIMEOUT_MS, HttpClient } from "../HttpClient";
import { getErrorMessage } from "../errors";
import {
  ClientFilesPageResponse,
  ClientFilesPageable,
  ClientFileMetadata,
  IClientFilesService,
} from "./IClientFilesService";

export class ClientFilesService implements IClientFilesService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 30000,
      headers: {},
    });
  }

  async getClientFiles(
    clientId: number,
    pageable: ClientFilesPageable,
    fileTypeId?: number,
    includePresignedURL?: boolean,
  ): Promise<ClientFilesPageResponse> {
    try {
      const params = new URLSearchParams({
        page: String(pageable.page),
        size: String(pageable.size),
      });

      if (pageable.sort) {
        params.append("sort", pageable.sort);
      }
      if (typeof fileTypeId === "number") {
        params.append("fileTypeId", String(fileTypeId));
      }
      if (typeof includePresignedURL === "boolean") {
        params.append("includePresignedURL", String(includePresignedURL));
      }

      return await this.httpClient.get<ClientFilesPageResponse>(
        `/clientFiles/client/${clientId}?${params.toString()}`,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar os ficheiros do cliente. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async uploadClientFile(
    metadata: ClientFileMetadata,
    file: File | Blob,
  ): Promise<number> {
    try {
      const formData = new FormData();
      formData.append(
        "metadata",
        new Blob([JSON.stringify(metadata)], { type: "application/json" }),
      );
      formData.append("file", file);

      return await this.httpClient.post<number>(
        "/clientFiles",
        formData,
        {
          timeout: FILE_TRANSFER_TIMEOUT_MS,
          headers: {
            Accept: "application/json",
          },
        },
        true,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar o ficheiro do cliente. Confirme o tipo e tamanho do ficheiro.",
      );
      throw new Error(errorMessage);
    }
  }
}
